<template>
  <div class="table-filter d-flex align-items-start">
    <div v-if="rangeErrorVisible" class="alerts">
      <div class="alert-wrapper fixed">
        <div class="alert alert-danger">
          <div class="alert__inner d-flex align-items-center justify-content-between">
            <span class="alert__text">{{ $t("maximum31dnu") }}</span>
            <div>
              <a class="ml-3 font-weight-bolder" @click="rangeErrorVisible = false">
                {{ $t("ok") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-control custom-control--date">
      <div class="custom-control__custom-input d-flex align-items-center justify-content-end">
        <DatePicker
          class="z-3"
          ref="picker"
          v-model="dateRange"
          teleport
          :locale="locale === 'cz' ? 'cs' : locale"
          :enable-time-picker="false"
          :range="{ partialRange: false }"
          :format="(date) => $t('datum')"
          :select-text="$t('zobrazit')"
          :cancel-text="$t('zpet')"
          :multi-calendars="2"
          @update:model-value="selectDate"
        >
          <template #input-icon />
        </DatePicker>
        <div class="atom-icon">
          <img src="@/assets/icons/ico-calendar.svg" />
        </div>
      </div>
      <div class="custom-control__selectedValues d-flex align-items-start justify-content-between">
        <div class="custom-control__selectedValues__value">
          <p>
            <span class="gray-text-light">{{ $t("od") }}</span>
            {{ $filters.date(dateRange?.[0] ?? "") }}
          </p>
          <p>
            <span class="gray-text-light">{{ $t("do") }}</span>
            {{ $filters.date(dateRange?.[1] ?? "") }}
          </p>
        </div>
        <img
          class="custom-control__selectedValues__icon pointer"
          src="@/assets/icons/actions/ico-delete-2.svg"
          @click="openDateRange()"
        />
      </div>
    </div>
    <div v-if="!noType" class="custom-control custom-control__select">
      <div class="custom-control__select__selected" :class="{ opened: openedSelect == 1 }" @click="toggleOpenSelect(1)">
        <span>{{ $t("typZpravy") }}</span>
      </div>
      <div class="custom-control__select__options" :class="{ opened: openedSelect == 1 }">
        <div
          class="custom-control__select__option d-flex align-items-center"
          @click="
            () => {
              filterType('down')
              openedSelect = 0
            }
          "
        >
          <div class="check">
            <img v-if="selectedFilters.types.indexOf('down') > -1" src="@/assets/icons/check.svg" />
          </div>
          <span class="font-weight-light">{{ $t("doZarizeni") }}</span>
        </div>
        <div
          class="custom-control__select__option d-flex align-items-center"
          @click="
            () => {
              filterType('up')
              openedSelect = 0
            }
          "
        >
          <div class="check">
            <img v-if="selectedFilters.types.indexOf('up') > -1" src="@/assets/icons/check.svg" />
          </div>
          <span class="font-weight-light">{{ $t("zeZarizeni") }}</span>
        </div>
      </div>
      <div v-if="selectedFilters.types.length > 0" class="custom-control__selectedValues">
        <div
          v-for="(type, index) in selectedFilters.types"
          :key="index + 't'"
          class="d-flex align-items-start justify-content-between"
        >
          <div class="custom-control__selectedValues__value">
            <p v-if="type == 'up'">
              {{ $t("zeZarizeni") }}
            </p>
            <p v-if="type == 'down'">
              {{ $t("doZarizeni") }}
            </p>
          </div>
          <img
            class="custom-control__selectedValues__icon pointer"
            src="@/assets/icons/actions/ico-delete-2.svg"
            @click="filterType(type)"
          />
        </div>
      </div>
    </div>
    <FormSelectMultiple
      v-if="!noStatus"
      class="mr-2"
      style="min-width: 200px"
      multiple
      selected-below
      :value="selectedFilters.statuses"
      :items="messageStatuses"
      item-text="text"
      item-value="value"
      :placeholder="$t('MSG_STATUS')"
      @change="selectedFilters.statuses = $event"
    />
    <!-- hidden by issue #119
    <div class="custom-control custom-control__select">
      <div
        class="custom-control__select__selected"
        v-bind:class="{ opened: openedSelect == 2 }"
        @click="toggleOpenSelect(2)"
      >
        {{ $t("stavZpravy") }}
      </div>
      <div
        class="custom-control__select__options"
        v-bind:class="{ opened: openedSelect == 2 }"
      >
        <div
          class="custom-control__select__option d-flex align-items-center"
          @click="
            filterState('OK');
            openedSelect = 0;
          "
        >
          <div class="check">
            <img
              src="@/assets/icons/check.svg"
              v-if="selectedFilters.states.indexOf('OK') > -1"
            />
          </div>
          <span class="font-weight-light">OK</span>
        </div>
        <div
          class="custom-control__select__option d-flex align-items-center"
          @click="
            filterState('?');
            openedSelect = 0;
          "
        >
          <div class="check">
            <img
              src="@/assets/icons/check.svg"
              v-if="selectedFilters.states.indexOf('?') > -1"
            />
          </div>
          <span class="font-weight-light">?</span>
        </div>
        <div
          class="custom-control__select__option d-flex align-items-center"
          @click="
            filterState('inFront');
            openedSelect = 0;
          "
        >
          <div class="check">
            <img
              src="@/assets/icons/check.svg"
              v-if="selectedFilters.states.indexOf('inFront') > -1"
            />
          </div>
          <span class="font-weight-light">{{ $t("veFronte") }}</span>
        </div>
      </div>
      <div
        v-if="selectedFilters.states.length > 0"
        class="custom-control__selectedValues"
      >
        <div
          v-for="(state, index) in selectedFilters.states"
          :key="index + 't'"
          class="d-flex align-items-start justify-content-between"
        >
          <div class="custom-control__selectedValues__value">
            <p v-if="state == 'inFront'">{{ $t("veFronte") }}</p>
            <p v-if="state == 'OK'">{{ $t("OK") }}</p>
            <p v-if="state == '?'">{{ $t("?") }}</p>
          </div>
          <img
            class="custom-control__selectedValues__icon pointer"
            src="@/assets/icons/actions/ico-delete-2.svg"
            @click="filterState(state)"
          />
        </div>
      </div>
    </div>
    -->
    <div v-if="!fulltextDisabled" class="custom-control custom-control--date">
      <div class="custom-control__custom-input d-flex align-items-center justify-content-between">
        <input
          id="guisearch"
          ref="searchInput"
          v-model="search"
          type="text"
          class="w-100"
          :placeholder="this.$t('Vyhledávání')"
          autofocus
        />
      </div>
      <div
        v-if="search.length > 0"
        class="custom-control__selectedValues d-flex align-items-start justify-content-between"
      >
        <div class="custom-control__selectedValues__value">
          {{ search }}
        </div>
        <img
          class="custom-control__selectedValues__icon pointer"
          src="@/assets/icons/actions/ico-delete-2.svg"
          @click="search = ''"
        />
      </div>
    </div>

    <button
      class="btn btn-primary d-flex align-items-center justify-content-center"
      @click="
        () => {
          filter()
          setSearch()
        }
      "
    >
      <div class="atom-icon">
        <img src="@/assets/icons/actions/ico-search-white.svg" />
      </div>
      {{ $t("hledat") }}
    </button>
    <button
      class="btn btn-primary d-flex ml-2 align-items-center justify-content-center"
      @click="
        () => {
          filter()
          resetSearch()
        }
      "
    >
      <div class="atom-icon">
        <img src="@/assets/icons/actions/ico-refresh.svg" />
      </div>
      {{ $t("RESET_MESSAGE_FILTER") }}
    </button>
  </div>
</template>

<script>
import _ from "lodash"
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue"
import DatePicker from "@vuepic/vue-datepicker"
import "@vuepic/vue-datepicker/dist/main.css"

export default {
  components: { FormSelectMultiple, DatePicker },
  props: {
    rows: Array,
    from: String,
    to: String,
    all: Array,
    dateChanged: Boolean,
    count: Number,
    toApplyFilter: Boolean,
    orderBy: String,
    orderType: String,
    noType: Boolean,
    fulltextDisabled: Boolean,
    selectSuspended: Boolean,
    hideSuspendedState: {
      type: Boolean,
      default: true
    },
    noStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: "",
      dateFrom: "",
      dateTo: "",
      type: "",
      state: "",
      openedSelect: 0,
      date: null,
      dateRange: [null, null],
      selectedFilters: {
        types: ["up", "down"],
        states: ["OK", "inFront", "?", "TEST"],
        statuses: []
      },
      rangeErrorVisible: false
    }
  },
  computed: {
    messageStatuses() {
      const statuses = [
        { value: "normal", text: this.$t("NORMAL") },
        { value: "preregistration", text: this.$t("PREREGISTRATION") }
      ]

      if (!this.hideSuspendedState) {
        statuses.push({ value: "suspended", text: this.$t("FILTER_SUSPENDED") })
      }

      return statuses
    },
    locale() {
      return this.$i18n.locale
    },
    uniqRows() {
      return _.uniq(this.rows, "message.EUI")
    },
    uniqAll() {
      return _.uniq(this.all, "message.EUI")
    },
    minDate() {
      let parsed = Date.parse(this.dateRange[0])
      let x = new Date(parsed - 31 * 24 * 60 * 60 * 1000)
      return x
    },
    maxDate() {
      let parsed = Date.parse(this.dateRange[1])
      let x = new Date(parsed + 31 * 24 * 60 * 60 * 1000)
      return x
    }
  },
  watch: {
    selectSuspended() {
      if (this.selectSuspended) {
        this.selectedFilters.statuses = [{ value: "suspended", text: this.$t("FILTER_SUSPENDED") }]
        this.filter()
        this.$emit("selectedSuspended")
      }
    },
    selectedFilters: {
      deep: true,
      handler() {
        localStorage.deviceMessageFilter = JSON.stringify(this.selectedFilters)
      }
    },
    from() {
      this.dateRange[0] = this.from
    },
    to() {
      this.dateRange[1] = this.to
    },
    dateChanged() {
      if (this.dateChanged == true) {
        this.applyFilter()
      }
    },
    rows() {
      if (this.uniqRows.length == this.count && this.dateChanged == true) {
        this.applyFilter()
      }
    }
  },
  mounted() {
    if (this.from !== "" && this.to !== "") {
      this.dateRange = [this.from, this.to]
    }
    if (localStorage.deviceMessageFilter) {
      this.selectedFilters = JSON.parse(localStorage.deviceMessageFilter)
    } else {
      this.selectedFilters.statuses = this.messageStatuses.filter((status) => status.value !== "suspended")
    }

    this.filter()
    this.$emit("statusesChanged", this.selectedFilters.statuses)
    this.$emit("typesChange", this.selectedFilters.types)
  },
  methods: {
    filter() {
      if (!this.dateRange) {
        return
      }

      this.$emit("statusesChanged", this.selectedFilters.statuses)
      if (
        this.to !== new Date(this.dateRange[1]).toISOString() ||
        this.from !== new Date(this.dateRange[0]).toISOString()
      ) {
        this.setTo(new Date(this.dateRange[1]).toISOString())
        this.setFrom(new Date(this.dateRange[0]).toISOString())
      } else {
        this.applyFilter()
      }
    },
    applyFilter() {
      /**
       * filtration over message type can be used only in device detail,
       * where we have all messages loaded
       *
       */
      if (!this.noType) {
        let filtered = []
        let items = []
        if (this.selectedFilters.types.length > 0 && this.selectedFilters.states.length == 0) {
          let filteredItems = []
          this.selectedFilters.types.forEach((type) => {
            let filtered = _.filter(this.all, { type: type })
            let concated = filteredItems.concat(filtered)
            filteredItems = concated
          })
          filtered = filteredItems
        } else if (this.selectedFilters.types.length == 0 && this.selectedFilters.states.length > 0) {
          let filteredItems = []
          this.selectedFilters.states.forEach((state) => {
            let filtered = _.filter(this.all, { state: state })
            let concated = filteredItems.concat(filtered)
            filteredItems = concated
          })
          filtered = filteredItems
        } else if (this.selectedFilters.types.length > 0 && this.selectedFilters.states.length > 0) {
          let filteredItemsStates = []
          this.selectedFilters.states.forEach((state) => {
            let filtered = _.filter(this.all, { state: state })
            let concated = filteredItemsStates.concat(filtered)
            filteredItemsStates = concated
          })
          let filteredItemsTypes = []
          this.selectedFilters.types.forEach((type) => {
            let filtered = _.filter(filteredItemsStates, { type: type })
            let concated = filteredItemsTypes.concat(filtered)
            filteredItemsTypes = concated
          })
          filtered = _.uniq(filteredItemsTypes, "message.EUI")
        } else {
          filtered = this.uniqAll
        }
        if (this.search == "") {
          items = filtered
        } else {
          //let searched = _.filter(filtered, {message: {data: this.search}});
          let searched = _.filter(filtered, (obj) => {
            return obj.message.data.indexOf(this.search) !== -1
          })
          items = searched
        }
        //
        let sorted = _.orderBy(items, this.orderBy, this.orderType)
        this.$emit("resetPaging")
        this.$emit("filteredItems", sorted)
      } else {
        this.$emit("resetPaging")
        this.$emit("reloadItems")
      }
    },
    toggleOpenSelect(value) {
      this.openedSelect = this.openedSelect == value ? 0 : value
    },
    filterType(type) {
      if (this.selectedFilters.types.indexOf(type) > -1) {
        this.selectedFilters.types.splice(this.selectedFilters.types.indexOf(type), 1)
      } else {
        this.selectedFilters.types.push(type)
      }
      this.$emit("typesChange", this.selectedFilters.types)
    },
    filterState(state) {
      if (this.selectedFilters.states.indexOf(state) > -1) {
        this.selectedFilters.states.splice(this.selectedFilters.states.indexOf(state), 1)
      } else {
        this.selectedFilters.states.push(state)
      }
    },
    setTo(date) {
      this.$emit("setTo", date)
    },
    setFrom(date) {
      this.$emit("setFrom", date)
    },
    setSearch() {
      this.$emit("setSearch", this.search)
    },
    /**
     * reset filter settings to defaults
     */
    resetSearch() {
      // we have to reset types to default values
      this.selectedFilters.types = ["up", "down"]
      this.selectedFilters.states = ["OK", "inFront", "?"]
      this.applyFilter()

      // call reset function
      this.$emit("resetSearch")
    },
    selectDate() {
      //
      const parsedTo = Date.parse(this.dateRange[1])
      let fr = String(this.dateRange[0])
      let tt = String(this.dateRange[1])
      if (this.from == "1970-01-01T00:00:00.000Z") {
        const dateFrom1 = new Date(parsedTo - 31 * 24 * 60 * 60 * 1000)
        this.dateRange[0] = dateFrom1.toISOString()
      } else if ((new Date(tt) - new Date(fr)) / 1000 / 60 / 60 / 24 >= 31) {
        const dateFrom1 = new Date(parsedTo - 31 * 24 * 60 * 60 * 1000)
        this.dateRange[0] = dateFrom1.toISOString()
        this.rangeErrorVisible = true
      } else {
        this.rangeErrorVisible = false
      }
    },
    openDateRange() {
      this.$refs.picker.togglePicker()
    }
  }
}
</script>

<style lang="scss" scoped></style>
